import { Directive, input } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';

import { skip } from 'rxjs';

import { CandidateAnalytics } from '@recruitee/candidate-util';
import { CollapsibleCardComponent } from '@recruitee/user-interface';

@Directive({
  selector: '[rtCollapsibleCardAnalytics]',
  standalone: true,
})
export class CollapsibleCardAnalyticsDirective {
  public rtCollapsibleCardAnalyticsKey = input.required<string | undefined>({
    alias: 'analyticsKey',
  });

  constructor(
    private candidateAnalytics: CandidateAnalytics,
    private collapsibleCard: CollapsibleCardComponent,
  ) {
    toObservable(this.collapsibleCard.isCollapsed)
      .pipe(skip(1), takeUntilDestroyed())
      .subscribe(() => {
        if (this.rtCollapsibleCardAnalyticsKey()?.length && this.candidateAnalytics) {
          this.candidateAnalytics.trackProfileSectionToggle(
            this.rtCollapsibleCardAnalyticsKey()!,
            this.collapsibleCard.isCollapsed() ? 'collapse' : 'expand',
          );
        }
      });
  }
}
